import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Challenge } from '@app/model/challenge';
import { HttpService, interceptorsToken } from 'library-explorer';
import { Observable } from 'rxjs';
import { DataResponse } from '@app/model/data-response.model';
import { LeaderboardUser } from '@app/model/leaderboard-user';

@Injectable({
  providedIn: 'root'
})
export class ChallengeApiService {

  constructor(private httpService: HttpService) { }

  public getChallengeByAlias(alias: string): Observable<Challenge> {
    const params = new HttpParams()
      .set('alias', alias)
      .set(interceptorsToken.HANDLE_PERMISSION_DENIED_PARAM, 'true');;
  
    return this.httpService.get<Challenge>('node', params);
  }

  public getChallengeById(id: string): Observable<Challenge> {
    const params = new HttpParams()
      .set('id', id)
      .set(interceptorsToken.HANDLE_PERMISSION_DENIED_PARAM, 'true');;
  
    return this.httpService.get<Challenge>('node', params);
  }

  public getChallengeRanking(id: string, offset = 0, limit = 10): Observable<DataResponse<LeaderboardUser>> {
    const params = new HttpParams()
      .set('offset', offset)
      .set('limit', limit);

    return this.httpService.get<DataResponse<LeaderboardUser>>(`challenge/${id}/ranking`, params);
  }

  public joinChallenge(id: string): Observable<void> {
    return this.httpService.post<void>(`challenge/${id}/join`, null);
  }
}

